import React from 'react';
import styles from './AnimatedVisuals.module.css';

const RobotVisual = () => {
  return (
    <div className={styles.visualContainer}>
      <div className={styles.robotHeader}>
        <div className={styles.robotIcon}>🤖</div>
        <span className={styles.robotTitle}>Robotic Automation</span>
      </div>
      <div className={styles.robotScene}>
        <div className={styles.robot}>
          <div className={styles.robotHead}>
            <div className={styles.robotEye} style={{ left: '25%' }}></div>
            <div className={styles.robotEye} style={{ right: '25%' }}></div>
          </div>
          <div className={styles.robotBody}>
            <div className={styles.robotChest}></div>
          </div>
          <div className={styles.robotArm} style={{ left: '-20px' }}>
            <div className={styles.armSegment}></div>
            <div className={styles.armSegment}></div>
          </div>
          <div className={styles.robotArm} style={{ right: '-20px' }}>
            <div className={styles.armSegment}></div>
            <div className={styles.armSegment}></div>
          </div>
          <div className={styles.robotLeg} style={{ left: '30%' }}>
            <div className={styles.legSegment}></div>
            <div className={styles.legSegment}></div>
          </div>
          <div className={styles.robotLeg} style={{ right: '30%' }}>
            <div className={styles.legSegment}></div>
            <div className={styles.legSegment}></div>
          </div>
        </div>
        <div className={styles.robotGlow}></div>
      </div>
      <div className={styles.robotStatus}>
        <span className={styles.statusDot}></span>
        <span>Automated & Operational</span>
      </div>
    </div>
  );
};

export default RobotVisual;

